import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoutes = ({ Component }) => {
  const isAuthenticated = !!localStorage.getItem("token"); // or your auth check

  if (!isAuthenticated) {
    // Not logged in, redirect to login page
    return <Navigate to="/login" replace />;
  }

  // Logged in, render the component
  return <Component />;
};

export default ProtectedRoutes;
